module.exports = __webpack_public_path__ + "static/media/Error.8a6aed6d.svg";